/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Visibility_HintInputs */

const cs_portals_visibility_hint = /** @type {(inputs: Portals_Visibility_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publikace na webu je oddělená od exportu na portály. Skrýt na webu neodebere portálové přepínače.`)
};

const en_portals_visibility_hint = /** @type {(inputs: Portals_Visibility_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Website publish is separate from portal export. Unpublishing the website does not remove portal toggles.`)
};

/**
* | output |
* | --- |
* | "Website publish is separate from portal export. Unpublishing the website does not remove portal toggles." |
*
* @param {Portals_Visibility_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_visibility_hint = /** @type {((inputs?: Portals_Visibility_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Visibility_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_visibility_hint(inputs)
	return cs_portals_visibility_hint(inputs)
});